export function menuConfig() {
    return {
        label: { textTransform: "none" },
        mainMenu: { item: { textTransform: "none" } },
        tabNavigation: { item: { textTransform: "none" } }
    };
}
